import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
} from "@mui/material";

const Button = (props: MuiButtonProps) => {
  const { color = "primary", variant = "contained" } = props;
  return <MuiButton color={color} variant={variant} {...props}></MuiButton>;
};

export default Button;
